import { render, staticRenderFns } from "./b-ticket-additional-info.vue?vue&type=template&id=c3a6cc8e&scoped=true"
import script from "./b-ticket-additional-info.vue?vue&type=script&lang=ts"
export * from "./b-ticket-additional-info.vue?vue&type=script&lang=ts"
import style0 from "./b-ticket-additional-info.vue?vue&type=style&index=0&id=c3a6cc8e&prod&lang=postcss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c3a6cc8e",
  null
  
)

export default component.exports